import { Buffer } from 'buffer';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';

import './lib/sentry';
import App from './app';

window.Buffer = Buffer;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
